import { useState, useEffect } from 'react';
import { useTheme } from '../context/theme';

export default function PWAInstallPrompt() {
  const { theme, isDark } = useTheme();
  const [show, sS] = useState(false);
  const [platform, setPlatform] = useState('generic');

  useEffect(() => {
    if (localStorage.getItem('pwa-install-dismissed')) return;
    const ua = navigator.userAgent || '';
    const isIOS = /iPad|iPhone|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const isStandalone = window.navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches;
    if (isStandalone) return;
    if (isIOS) { setPlatform('ios'); sS(true); return; }
    if (/Android/.test(ua)) { setPlatform('android'); } else { setPlatform('desktop'); }
    if (window._pwaPromptEvent) { sS(true); }
    const handler = () => sS(true);
    window.addEventListener('pwa-install-available', handler);
    window.addEventListener('pwa-installed', () => sS(false));
    return () => window.removeEventListener('pwa-install-available', handler);
  }, []);

  if (!show) return null;

  const dismiss = () => { localStorage.setItem('pwa-install-dismissed', '1'); sS(false); };

  const doInstall = async () => {
    if (window._pwaPromptEvent) {
      window._pwaPromptEvent.prompt();
      const { outcome } = await window._pwaPromptEvent.userChoice;
      if (outcome === 'accepted') sS(false);
      window._pwaPromptEvent = null;
    }
  };

  const bgColor = 'linear-gradient(135deg,#1e1e24,#2a2a32)';
  const borderColor = '#3a3a3e';
  const textPrimary = '#f5f5f5';
  const textSecondary = '#9ca3af';

  const getInstructions = () => {
    if (platform === 'ios') {
      const ua = navigator.userAgent || '';
      const isChromeIOS = /CriOS/.test(ua);
      const isFirefoxIOS = /FxiOS/.test(ua);
      if (isChromeIOS || isFirefoxIOS) {
        return (
          <span>
            <strong style={{ color: '#F59E0B' }}>⚠ Open in Safari first</strong> — tap{' '}
            <span style={{ display: 'inline-block', width: 20, height: 20, background: isDark ? '#333' : '#ddd', borderRadius: 4, textAlign: 'center', lineHeight: '20px', fontSize: 14, verticalAlign: 'middle', margin: '0 3px' }}>□↑</span>
            {' '}→ <strong style={{ color: textPrimary }}>"Add to Home Screen"</strong>
          </span>
        );
      }
      return (
        <span>
          Tap <span style={{ display: 'inline-block', width: 20, height: 20, background: isDark ? '#333' : '#ddd', borderRadius: 4, textAlign: 'center', lineHeight: '20px', fontSize: 14, verticalAlign: 'middle', margin: '0 3px' }}>□↑</span>
          {' '}in the bottom bar → <strong style={{ color: textPrimary }}>"Add to Home Screen"</strong>
        </span>
      );
    }
    if (platform === 'android' && window._pwaPromptEvent) {
      return <span>Tap <strong style={{ color: '#4ADE80', cursor: 'pointer' }} onClick={doInstall}>Install Now</strong> for quick access</span>;
    }
    if (window._pwaPromptEvent) {
      return <span>Click <strong style={{ color: '#4ADE80', cursor: 'pointer' }} onClick={doInstall}>Install</strong> to add Lightning Partners HQ to your desktop</span>;
    }
    return <span>Open browser menu → <strong style={{ color: textPrimary }}>"Install App"</strong></span>;
  };

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999, padding: '16px 20px',
      background: bgColor, borderTop: '2px solid ' + borderColor,
      boxShadow: '0 -4px 20px rgba(0,0,0,' + (isDark ? '0.5' : '0.15') + ')', animation: 'slideUp .3s ease'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', maxWidth: 500, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flex: 1 }}>
          <img src="/icon-192.png" alt="Lightning Partners HQ" style={{ width: 40, height: 40, borderRadius: 10 }} onError={e => { e.target.style.display = 'none'; }} />
          <div>
            <div style={{ fontSize: 15, fontWeight: 700, color: textPrimary, marginBottom: 2 }}>Install Lightning Partners HQ</div>
            <div style={{ fontSize: 13, color: textSecondary, lineHeight: 1.4 }}>{getInstructions()}</div>
          </div>
        </div>
        <button onClick={dismiss} style={{
          background: 'none', border: '1px solid ' + (isDark ? '#3a3a3e40' : '#ccc'), borderRadius: 8,
          color: textSecondary, cursor: 'pointer', fontSize: 13, padding: '6px 12px', marginLeft: 12, flexShrink: 0
        }}>✕</button>
      </div>
    </div>
  );
}
